module.exports = __webpack_public_path__ + "img/75.1ff43e3.jpg";